﻿$.fn.dxCtrlViewerVideo = function custom_dxCtrlViewerVideo(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlviewervideo");
        this.instance = new cdxCtrlViewerVideo(this, option);
    }
    return this;
}

window.cdxCtrlViewerVideo = function (container, option) {
    var Me = this;
    if (typeof option.value == 'undefined') option.value = null;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty();
        container.css({
            "height": "100%",
            "width": "100%"
        })

        var $DivImg = $("<div style='padding:10px 0 0 10px;'/>").appendTo(container)
        var $DivVideo = $("<div/>").appendTo(container)
        resizeObserver.mAdd($DivImg, function () { $DivVideo.css("height", "calc(100% - " + $DivImg.innerHeight() + "px)") })
        $DivVideo.css({
            "display": "flex",
            "align-items": "center",
            "justify-content": "center",
            "height": "calc(100% - " + $DivImg.innerHeight() + "px)",
            "width": "100%"
        })
        if (option.showTitleAppli) {
            var $img = $("<img src='" + parametre.imgphrase + "' style='cursor:pointer;opacity:0.5;width:150px;'/>").appendTo($DivImg)
            $img.on("click", function (e) {
                window.open(parametre.url_site_vitrine,"_blank")
            })
        }
        //var $video = $("<video style='width:100%;max-width:800px;object-fit:cover;' playsinline='true' width='100%' autoplay='false' muted='false' loop='false' preload='auto'/>").appendTo(container)
        var $video = $("<video style='width:100%;max-width:800px;object-fit:cover;clip-path: inset(2px 2px);' controls width='100%' preload='auto'/>").appendTo($DivVideo)
        var $source = $("<source src='" + option.url + "'/>").appendTo($video)
    }

    this.focus = function () { }

    mConstruit();
}